import gameAssets from "@themed-assets";
import React from "react";
import { Separator } from "../ui/separator";
import { formatDistance } from "date-fns";

function TourneyDetailsRules({ selectedTourneyDetails }) {
  const rulesObject = [
    {
      title: "Additional info",
      icon: gameAssets.CoffeeCupIcon,
      content: selectedTourneyDetails?.tourneyRules || "",
    },
    {
      title: "Break",
      icon: gameAssets.CoffeeCupIcon,
      content:
        "There is a 5 minute break every 25 minutes past the hour. For instance, if the tournament started at 12:30 PM, the break will take place from 1:25 PM to 1:30 PM.",
    },
    {
      title: "Players Per Table",
      icon: gameAssets.UserGroupIcon,
      content: `Maximum ${
        selectedTourneyDetails?.playersPerTable || 0
      } players per table`,
    },
    {
      title: "Late Registration",
      icon: gameAssets.ClockIcon,
      content: selectedTourneyDetails?.lateRegistrationAllowed
        ? `Late registration for the tournament will be available for ${formatDistance(
            new Date(selectedTourneyDetails?.tourneyStartTime),
            new Date(selectedTourneyDetails?.lateRegEndTime)
          )} after the start of the tournament.`
        : "",
    },
    {
      title: "Re-Entries / Re-Buys",
      icon: gameAssets.RefreshIcon,
      content: `${
        selectedTourneyDetails?.totalReEntryCount || 0
      } re-entries allowed till the end of late registration. Re-entry amount is ${
        selectedTourneyDetails?.reEntry?.reEntrySettings?.reentryEntryFee || 0
      }`,
    },
  ];

  return (
    <div className="">
      {rulesObject.map(
        (sec, idx) =>
          sec.content && (
            <div key={idx}>
              <div
                className={`p-3 rounded py-4 ${
                  idx === 0 ? "bg-foreground" : "bg-transparent"
                }`}
              >
                <div className="flex items-center gap-2 mb-2">
                  <img
                    src={sec.icon}
                    height={14}
                    width={14}
                    className="object-cover"
                  />
                  <h2 className="font-medium text-primary text-sm">
                    {sec.title}
                  </h2>
                </div>
                {idx == 0 ? (
                  sec?.content
                    ?.split("\n")
                    ?.map((item, key) => (
                      <p className="text-xs text-secondary font-medium">
                        {item}
                      </p>
                    ))
                ) : (
                  <p className="text-xs pb-1 leading-relaxed text-secondary font-medium">
                    {sec.content}
                  </p>
                )}
              </div>
              {idx > 0 && (
                <Separator
                  className={
                    "bg-gradient-to-r from-foregeround via-cta to-foreground "
                  }
                />
              )}
            </div>
          )
      )}
    </div>
  );
}

export default TourneyDetailsRules;
